function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
import { useCallback, useRef } from 'react';
import { ENV_CACHE } from "../../../utils";
export var useFlowOperate = function useFlowOperate(options) {
  var project = options.project,
    miniProgramEnv = options.miniProgramEnv,
    taskDetail = options.taskDetail,
    onMessage = options.onMessage,
    apiToOperate = options.apiToOperate,
    apiOperate = options.apiOperate,
    onConfirm = options.onConfirm,
    onOperateSuccess = options.onOperateSuccess,
    onOpenOperatePage = options.onOpenOperatePage,
    onOpenCreatePage = options.onOpenCreatePage,
    onOpenCustomPage = options.onOpenCustomPage;
  var actionRef = useRef({
    onMessage: onMessage,
    apiToOperate: apiToOperate,
    apiOperate: apiOperate,
    onConfirm: onConfirm,
    onOperateSuccess: onOperateSuccess,
    onOpenOperatePage: onOpenOperatePage,
    onOpenCreatePage: onOpenCreatePage,
    onOpenCustomPage: onOpenCustomPage
  });
  actionRef.current = {
    onMessage: onMessage,
    apiToOperate: apiToOperate,
    apiOperate: apiOperate,
    onConfirm: onConfirm,
    onOperateSuccess: onOperateSuccess,
    onOpenOperatePage: onOpenOperatePage,
    onOpenCreatePage: onOpenCreatePage,
    onOpenCustomPage: onOpenCustomPage
  };
  var handleOperate = useCallback( /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(action) {
      var _actionRef$current, onMessage, apiToOperate, apiOperate, onConfirm, onOperateSuccess, onOpenOperatePage, onOpenCreatePage, onOpenCustomPage, operateType, operateName, flowLink, subFlowCode, subFlowVersion, _ref2, businessCode, taskOrderId, subFlowParams, confirmed, res, _flowLink$linkPath, linkPath, variables, pathParse, _ref3, miniProgram, web, path, devHost, betaHost, prodHost, _path, hostMap, host, url, _ref4, _web, curHost, _web$devHost, _devHost, _web$betaHost, _betaHost, _web$prodHost, _prodHost, _path2, getEnv, _hostMap, _host, _url, actionData, _actionData, directHandle, formSchema, formValue, modifyMainFormSchema, modifyMainFormValue, forceUseDraft, orderDraftContent, _confirmed, _res, formMap, forms;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _actionRef$current = actionRef.current, onMessage = _actionRef$current.onMessage, apiToOperate = _actionRef$current.apiToOperate, apiOperate = _actionRef$current.apiOperate, onConfirm = _actionRef$current.onConfirm, onOperateSuccess = _actionRef$current.onOperateSuccess, onOpenOperatePage = _actionRef$current.onOpenOperatePage, onOpenCreatePage = _actionRef$current.onOpenCreatePage, onOpenCustomPage = _actionRef$current.onOpenCustomPage;
            operateType = action.name, operateName = action.title, flowLink = action.flowLink, subFlowCode = action.subFlowCode, subFlowVersion = action.subFlowVersion;
            _ref2 = taskDetail || {}, businessCode = _ref2.businessCode, taskOrderId = _ref2.taskOrderId;
            if (taskOrderId) {
              _context.next = 6;
              break;
            }
            console.error('缺少 taskOrderId');
            return _context.abrupt("return", false);
          case 6:
            console.log('handleTaskAction', {
              taskOrderId: taskOrderId,
              action: action
            }); // 勿删
            // A. #1 发起子流程(单实例), 打开任务发起页(带参数)
            if (!(subFlowCode && subFlowVersion != null)) {
              _context.next = 10;
              break;
            }
            subFlowParams = action.subFlowParams;
            return _context.abrupt("return", onOpenCreatePage({
              subFlowCode: subFlowCode,
              subFlowVersion: subFlowVersion,
              subFlowParams: subFlowParams
            }));
          case 10:
            if (!(operateType === 'END_APPLY_SUB_FLOW')) {
              _context.next = 28;
              break;
            }
            _context.next = 13;
            return onConfirm("\u786E\u8BA4\u7ED3\u675F\u53D1\u8D77\u4EFB\u52A1\u5417?");
          case 13:
            confirmed = _context.sent;
            if (confirmed) {
              _context.next = 16;
              break;
            }
            return _context.abrupt("return", false);
          case 16:
            _context.prev = 16;
            _context.next = 19;
            return apiOperate({
              taskOrderId: taskOrderId,
              operateType: operateType
            });
          case 19:
            res = _context.sent;
            onOperateSuccess === null || onOperateSuccess === void 0 || onOperateSuccess(res);
            return _context.abrupt("return", true);
          case 24:
            _context.prev = 24;
            _context.t0 = _context["catch"](16);
            console.error(_context.t0);
            return _context.abrupt("return", false);
          case 28:
            if (!flowLink) {
              _context.next = 71;
              break;
            }
            // 暂不支持参数映射
            _flowLink$linkPath = flowLink.linkPath, linkPath = _flowLink$linkPath === void 0 ? {} : _flowLink$linkPath;
            variables = action.flowLinkVariables || {};
            pathParse = function pathParse(path) {
              var result = path.match(/\{([^{}]+)\}/g) || [];
              var _iterator = _createForOfIteratorHelper(result),
                _step;
              try {
                for (_iterator.s(); !(_step = _iterator.n()).done;) {
                  var temp = _step.value;
                  var key = temp.slice(1, -1);
                  path = path.replace(temp, encodeURIComponent(variables[key] || ''));
                }
              } catch (err) {
                _iterator.e(err);
              } finally {
                _iterator.f();
              }
              return path;
            };
            if (!(project === 'mini_program')) {
              _context.next = 54;
              break;
            }
            if (!linkPath.miniProgram) {
              _context.next = 51;
              break;
            }
            _ref3 = linkPath.miniProgram || {}, miniProgram = _ref3.miniProgram, web = _ref3.web;
            if (!miniProgram) {
              _context.next = 45;
              break;
            }
            path = miniProgram.path;
            _context.prev = 37;
            return _context.abrupt("return", onOpenCustomPage({
              url: pathParse(path),
              type: 'mini_program'
            }));
          case 41:
            _context.prev = 41;
            _context.t1 = _context["catch"](37);
            console.error(_context.t1);
            return _context.abrupt("return", undefined);
          case 45:
            if (!web) {
              _context.next = 51;
              break;
            }
            devHost = web.devHost, betaHost = web.betaHost, prodHost = web.prodHost, _path = web.path;
            hostMap = {
              develop: devHost,
              trial: process.env.NODE_ENV === 'production' ? prodHost : betaHost,
              beta: betaHost,
              release: prodHost
            }; // 小程序端通过 envVersion 来切换 host
            host = hostMap[miniProgramEnv || 'release'];
            url = "".concat(host).concat(pathParse(_path));
            return _context.abrupt("return", onOpenCustomPage({
              url: url,
              type: 'web'
            }));
          case 51:
            _context.next = 53;
            return onMessage({
              type: 'info',
              content: "\u8BF7\u5728".concat(linkPath.web ? '电脑端' : '其他端', "\u64CD\u4F5C")
            });
          case 53:
            return _context.abrupt("return", false);
          case 54:
            if (!(project === 'web')) {
              _context.next = 67;
              break;
            }
            _ref4 = linkPath.web || {}, _web = _ref4.web;
            if (!_web) {
              _context.next = 64;
              break;
            }
            curHost = window.location.origin;
            _web$devHost = _web.devHost, _devHost = _web$devHost === void 0 ? curHost : _web$devHost, _web$betaHost = _web.betaHost, _betaHost = _web$betaHost === void 0 ? curHost : _web$betaHost, _web$prodHost = _web.prodHost, _prodHost = _web$prodHost === void 0 ? curHost : _web$prodHost, _path2 = _web.path;
            getEnv = function getEnv() {
              var isProd = process.env.REACT_APP_ENV === 'production';
              if (isProd) {
                return 'prod';
              }
              var fullSubdomain = window.location.host.split('.').slice(0, -2).map(function (i) {
                return i.toLowerCase();
              });
              var storageEnv = localStorage.getItem(ENV_CACHE);
              return storageEnv || (fullSubdomain[1].includes('beta') ? 'beta' : 'dev');
            };
            _hostMap = {
              dev: _devHost,
              beta: _betaHost,
              prod: _prodHost
            };
            _host = _hostMap[getEnv()];
            _url = "".concat(_host).concat(pathParse(_path2));
            return _context.abrupt("return", onOpenCustomPage({
              url: _url,
              type: 'web'
            }));
          case 64:
            _context.next = 66;
            return onMessage({
              type: 'info',
              content: "\u8BF7\u5728".concat(linkPath.miniProgram ? '小程序' : '其他端', "\u64CD\u4F5C")
            });
          case 66:
            return _context.abrupt("return", false);
          case 67:
            console.error(new Error('未匹配跳转规则, 请检查按钮配置'), {
              flowLink: flowLink
            });
            _context.next = 70;
            return onMessage({
              type: 'warning',
              content: '请检查跳转配置'
            });
          case 70:
            return _context.abrupt("return", false);
          case 71:
            _context.prev = 71;
            _context.next = 74;
            return apiToOperate({
              taskOrderId: taskOrderId,
              operateType: operateType
            });
          case 74:
            actionData = _context.sent;
            _context.next = 80;
            break;
          case 77:
            _context.prev = 77;
            _context.t2 = _context["catch"](71);
            console.error('获取操作配置异常', _context.t2);
          case 80:
            if (actionData) {
              _context.next = 82;
              break;
            }
            return _context.abrupt("return", false);
          case 82:
            console.log('actionData', actionData); // 勿删
            _actionData = actionData, directHandle = _actionData.directHandle, formSchema = _actionData.formSchema, formValue = _actionData.formValue, modifyMainFormSchema = _actionData.modifyMainFormSchema, modifyMainFormValue = _actionData.modifyMainFormValue, forceUseDraft = _actionData.forceUseDraft, orderDraftContent = _actionData.orderDraftContent;
            if (!directHandle) {
              _context.next = 102;
              break;
            }
            _context.next = 87;
            return onConfirm("\u786E\u8BA4".concat(operateName, "\u4EFB\u52A1\u5417?"));
          case 87:
            _confirmed = _context.sent;
            if (_confirmed) {
              _context.next = 90;
              break;
            }
            return _context.abrupt("return", false);
          case 90:
            _context.prev = 90;
            _context.next = 93;
            return apiOperate({
              taskOrderId: taskOrderId,
              operateType: operateType
            });
          case 93:
            _res = _context.sent;
            onOperateSuccess === null || onOperateSuccess === void 0 || onOperateSuccess(_res);
            return _context.abrupt("return", true);
          case 98:
            _context.prev = 98;
            _context.t3 = _context["catch"](90);
            console.error(_context.t3);
            return _context.abrupt("return", false);
          case 102:
            // 2. 跳转处理页
            formMap = [];
            if (formSchema) {
              formMap.push({
                type: 'HandleForm',
                schema: formSchema,
                value: formValue,
                forceDraft: forceUseDraft,
                draftContent: orderDraftContent
              });
            }
            if (modifyMainFormSchema) {
              formMap.push({
                type: 'MainForm',
                schema: modifyMainFormSchema,
                value: modifyMainFormValue,
                forceDraft: forceUseDraft,
                draftContent: orderDraftContent ? _objectSpread(_objectSpread({}, orderDraftContent), {}, {
                  formValue: orderDraftContent.modifyMainFormValue
                }) : orderDraftContent
              });
            }
            forms = Object.values(formMap).filter(function (i) {
              return Boolean(i);
            });
            return _context.abrupt("return", onOpenOperatePage(_objectSpread(_objectSpread({}, actionData), {}, {
              businessCode: businessCode,
              operateName: operateName,
              forms: forms,
              forceUseDraft: forceUseDraft,
              orderDraftContent: orderDraftContent
            })));
          case 107:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[16, 24], [37, 41], [71, 77], [90, 98]]);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }(), [miniProgramEnv, project, taskDetail]);
  return {
    handleOperate: handleOperate
  };
};